import { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';

import { collection, doc } from 'firebase/firestore';

import { useNavigate } from 'react-router-dom';

import GratiPageWrapper from '../components/common/GratiPageWrapper';
import CompetitionEditor from '../components/competition/CompetitionEditor';
import { ActionProps, useApp } from '../contextProviders/AppProvider';
import { useAuth } from '../contextProviders/AuthProvider';
import { useCompetitionMutators } from '../dataMutators/useCompetitionMutators';
import { firestore } from '../firebase';
import Competition from '../types/Competition';
import { DefaultObjects } from '../types/DefaultObjects';

export default function CompetitionCreatePage(): ReactElement {
  const navigate = useNavigate();
  const { setPageName } = useApp();
  const { isGod } = useAuth();
  const { addCompetition } = useCompetitionMutators();

  const [pageActions, setPageActions] = useState<ActionProps[] | null>(null);
  const [godActions, setGodActions] = useState<ReactElement | null>(null);

  useEffect(() => {
    setPageName('Create Competition');
  }, [setPageName]);

  const competition = useMemo((): Competition => {
    const compRef = doc(collection(firestore, 'competition'));
    return {
      ...DefaultObjects.Competition,
      itemId: compRef.id,
    };
  }, []);

  const handleCreate = useCallback((newCompetition: Competition) => {
    addCompetition(newCompetition).then((added) => {
      if (added) {
        navigate('/competition-library', { replace: true });
      } else {
        console.error('Competition not added:', newCompetition);
      }
    });
  }, [addCompetition, navigate]);

  const handleActionsChange = useCallback((actions: ActionProps[] | null, godActionsArg: ReactElement | null) => {
    setPageActions(actions);
    setGodActions(godActionsArg);
  }, []);

  return (
    <GratiPageWrapper
      validateUser={() => isGod}
      pageActions={pageActions}
      godActions={godActions}
    >
      <CompetitionEditor
        competition={competition}
        isNew
        handleCreate={handleCreate}
        onActionsChange={handleActionsChange}
      />
    </GratiPageWrapper>
  );
}
